import script from "./CreateButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateButton.vue?vue&type=script&setup=true&lang=js"

import "./CreateButton.vue?vue&type=style&index=0&id=a51d4ca4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a51d4ca4"]])

export default __exports__